import React from "react";

import { useQueryClient } from "react-query";
import styled from "styled-components";
import theme from "../../styles/theme";
import { useNavigate } from 'react-router-dom';


const HeaderWrap = styled.div`
    position: sticky;
    top:0;
    width: 100%;
    padding: 0px 12px;
    height: 60px;
    background: linear-gradient(91.1deg, ${theme.color.primary.pupple} 11.83%, ${theme.color.primary.pupple} 100%) 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    .cta-area{
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 12px;
    }
    h2 {
        text-align: center;
        margin: 0;
        color: ${theme.color.black[80]};
        font-size: ${theme.fontSize.md};
        font-weight: 800;
    }
    z-index: 100;
`;

const Header = () => {

    const queryClient = useQueryClient();

    const navigate = useNavigate();

    const handleLogout = () => {
        localStorage.removeItem('USER');
        queryClient.resetQueries('USER', { exact: true });
        navigate('/');
    }

    return (
        <React.Fragment>
            <HeaderWrap>
                <div className="cta-area">
                    <h2 onClick={()=>navigate('/')}>TAMS</h2>
                </div>
                <div className="cta-area">
                    
                    <img src={'/images/ic_sign_out.svg'} onClick={handleLogout}/>
                </div>
            </HeaderWrap>
            
        </React.Fragment>
    )

}

// const Header = () => {

//     const queryClient = useQueryClient();
//     const [showQR, setShowQR] = useState(false);
//     const { data : user } = useQuery('USER', {});
    
//     const handleMenuClick = () => {
//         queryClient.setQueryData('M_MENU',{open:true});
//     }

//     return (
//         <React.Fragment>
//             <HeaderWrap>
//                 <div className="cta-area">
//                     <img src={'/images/ic_m_menu.svg'}  alt='' onClick={handleMenuClick} />
//                     <h2>TAMS</h2>
//                 </div>
//                 <div className="cta-area">
//                     <img src={'/images/ic_qrcode.svg'}  alt='' onClick={() => setShowQR(true)} />
//                     <img src={'/images/ic_sign_out.svg'} onClick={() => queryClient.resetQueries('USER', { exact: true })}/>
//                 </div>
//             </HeaderWrap>
//             { showQR === true && <QRReader closer={() => setShowQR(false)} /> }
//         </React.Fragment>
//     )

// }

export default Header;